import React, { useState, useRef } from "react";
import { Tabs } from "antd";
import DeliveryInfo from "./DeliveryInfo";
import DeliveryPricesInfo from "./DeliveryPricesInfo";
import ContentPageTitle from "../../../../common/ContentPageTitle";

const DeliverySettings = (props) => {
  const { business } = props;

  const [deliveryType, setDeliveryType] = useState(null);
  const deliveryInfoRef = useRef(null);

  const handleTabChange = (key) => {
    // Si salimos de la pestaña 1 (Delivery Info), revertimos los cambios
    if (deliveryInfoRef.current && deliveryInfoRef.current.resetForm) {
      deliveryInfoRef.current.resetForm();
    }
  };

  return (
    <>
      <ContentPageTitle title="Delivery Settings" icon="file-pen" />
      <div className="content-box" style={{ padding: 20 }}>
        <Tabs
          defaultActiveKey="1"
          type="card"
          size="default"
          onChange={handleTabChange}
        >
          <Tabs.TabPane tab="Delivery Info" key="1">
            <DeliveryInfo
              ref={deliveryInfoRef}
              business={business}
              setDeliveryType={setDeliveryType}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Delivery Prices" key="2">
            <DeliveryPricesInfo
              business={business}
              deliveryType={deliveryType}
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default DeliverySettings;
